import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
export var Copyright = function () { return (React.createElement(Typography, { variant: "body2", color: "textSecondary", align: "center", style: { marginBottom: '32px' } },
    'Copyright © ',
    React.createElement(Link, { color: "inherit", href: "#" }, "Rentaligo"),
    ' ' + new Date().getFullYear() + '.')); };
